//import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Inicio from './Paginas/Inicio';
import Registroest from './Paginas/Registroest';
import Header from './Componentes/Header';
import Reservas from './Paginas/Reservas';
import EditarEst from './Paginas/EditarEst';
import Informacion from './Paginas/informacion';
import Login from './Paginas/Login';
import Registrese from './Paginas/Registrese';
import Credenciales from './Paginas/Credenciales';
import ConfirmarCorreo from './Paginas/ConfirmarCorreo';
import Ofertas from './Paginas/Ofertas';
import { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Cambcontra from './Paginas/Cambcontra';
import { DataProvider } from './Componentes/DataContext';

export const ID_ESTABLECIMIENTO = 64;

function App() {
  axios.defaults.withCredentials = true;
  const [estado, setestado] = useState();
  const [corrio, setCorrio] = useState(false);

  useEffect(() => {
    const currentPath = window.location.pathname;
    const excludedPaths = ['/CambiodeContrasena', '/ConfirmarCorreo'];
    // Evitar chequeo de login en estas rutas
    if (excludedPaths.includes(currentPath)) {
      setestado(true);
      return;
    }
    const checkLogin = () => {
      axios
        .get(`${process.env.REACT_APP_HTTPS}/api/user/login`)
        .then((response) => {
          if (response.data.furulo === true) {
            if (response.data.Estado === 'Registrado') {
              setestado(null);
            }
            else if (response.data.Estado === 'Afiliado'){
              setestado(false);
            } else if (response.data.Estado === 'Registrado Pendiente' || response.data.Estado === 'Afiliado Pendiente') {
              setestado(true);
              toast.error('Su establecimiento esta pendiente de aprobación', {duration: 60*1000})
            }
              else {
              setestado(true);
              toast.error('Estado invalido')
            }
          } else {
            console.log('User is not logged in, redirecting to login...');
            if (currentPath !== '/') {
              window.location.replace(`${process.env.REACT_APP_HTTP}/`);
            }
            setestado(true);
          }
        })
        .catch((error) => {
          console.error('Error checking login:', error);
        });
    };
    // Run immediately on mount
    checkLogin();
  
    // Set interval to run every 5 minutes (300,000 ms)
    const intervalId = setInterval(checkLogin, 300000);
  
    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, [corrio]);

const corrios = () =>{
  setCorrio(!corrio)
}

  return (
  <Router>
    {estado === true ? (<>
      <Routes>
        <Route path='/' element={<Login Corrion={corrios}/>} />
        <Route path='/RegistroEstablecimiento' element={<Registroest />} />
        <Route path='/CambiodeContrasena' element={<Cambcontra />} />
        <Route path='/ConfirmarCorreo' element={<ConfirmarCorreo />} />
      </Routes>
    </>): estado === false ? (<>
      <div className='App'>
        <DataProvider>
        <Header/>
        <div className='display'>
          <Routes>
            <Route path='/' element={<Inicio />} />
            <Route path='/Reservas' element={<Reservas/> } />
            <Route path='/EditarEst' element={<EditarEst />} />
            <Route path='/Informacion' element={<Informacion />} />
            <Route path='/Credenciales' element={<Credenciales />} />
            <Route path='/Ofertas' element={<Ofertas Allcanchas/>} />
          </Routes>
        </div>
        </DataProvider>
      </div>
    </>): estado === null ? (<>
      <div className='App'>
          <Header/>
        <div className='display'>
          <Routes>
            <Route path='/' element={<EditarEst />} />
            <Route path='/Informacion' element={<Informacion />} />
            <Route path='/Pruebas' element={<Registrese/> } />
            <Route path='/Reservas' element={<Registrese/> } />
            <Route path='/EditarEst' element={<EditarEst />} />
            <Route path='/Credenciales' element={<Credenciales />}/>
          </Routes>
        </div>
      </div>
    </>): (<></>)}
    </Router>
  );
}

export default App;
